import { Store } from '@betgames/bg-state-manager';
import { TooltipName } from '@bg-shared/business/TooltipQueue/enums/TooltipName';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { playerSettingsStore } from '@bg-shared/business/PlayerSettings';
import { IQueueItem } from './interfaces/IQueueItem';

export class TooltipQueueStore extends Store<IQueueItem[]> {
    constructor() {
        super({
            key: 'TooltipQueue',
            default: [],
        });
    }

    public addToQueue(item: IQueueItem): void {
        if (this.isLast(item)) {
            return;
        }
        this.update((draft) => {
            draft.push(item);
        });
    }

    public removeFirst(): void {
        this.update((draft) => {
            draft.shift();
        });
    }

    public removeIfFirstInQueue(name: TooltipName): void {
        if (this.value[0]?.name === name) {
            this.removeFirst();
        }
    }

    public handleAddGuiTipToQueue(): void {
        if (
            partnerSettingsStore.partnerSettings.showGuiTip &&
            !playerSettingsStore.guiMode &&
            !playerSettingsStore.guiTipSeen
        ) {
            this.addToQueue({
                name: TooltipName.GUI_TIP,
            });
        }
    }

    public handeAddCasinoTipToQueue(): void {
        if (
            partnerSettingsStore.isCasinoHintShown &&
            !playerSettingsStore.casinoFallbackTooltipSeen
        ) {
            this.addToQueue({
                name: TooltipName.CASINO_WELCOME,
                duration: 5000,
            });
        }
    }

    private isLast(item: IQueueItem): boolean {
        return this.value[this.value.length - 1]?.name === item.name;
    }
}

export const tooltipQueueStore = new TooltipQueueStore();
